/**
 * Utility functions for billing and plan management
 */

/**
 * Determines if a plan requires a payment method to be selected.
 * Only the free plan and Pro 10 monthly plan can be selected without a payment method.
 *
 * @param planId - The plan identifier to check
 * @returns true if the plan requires a payment method, false otherwise
 */
export function planRequiresPaymentMethod(planId: string): boolean {
  return !["free", "10"].includes(planId);
}

/**
 * Determines if a payment method is required for a plan change, considering trial status.
 *
 * @param planId - The plan identifier to check
 * @param trialUsed - Whether the user has already used their free trial
 * @returns true if a payment method is required, false otherwise
 */
export function paymentMethodRequiredForPlanChange(planId: string, trialUsed: boolean): boolean {
  switch (planId) {
    case "free":
      return false;
    case "10":
      return trialUsed; // Require payment method if trial was already used
    default:
      return true; // All other plans require payment method
  }
}

/**
 * Determines if a plan supports free trials.
 * Only the Pro 10 monthly plan supports trials.
 *
 * @param planId - The plan identifier to check
 * @returns true if the plan supports free trials, false otherwise
 */
export function planSupportsFreeTrial(planId: string): boolean {
  return planId === "10";
}
